var statesByZip = { "PR": [{ "from": 601, "to": 987 }], "MA": [{ "from": 1001, "to": 2791 }], "RI": [{ "from": 2802, "to": 2921 }], "NH": [{ "from": 3031, "to": 3894 }], "ME": [{ "from": 3901, "to": 4992 }], "VT": [{ "from": 5001, "to": 5907 }], "CT": [{ "from": 6001, "to": 6389 }, { "from": 6401, "to": 6907 }], "NY": [{ "from": 6390, "to": 6390 }, { "from": 10001, "to": 14905 }], "NJ": [{ "from": 7001, "to": 8904 }], "PA": [{ "from": 15001, "to": 19611 }], "DE": [{ "from": 19701, "to": 19979 }], "DC": [{ "from": 20001, "to": 20064 }, { "from": 20202, "to": 20593 }], "VA": [{ "from": 20105, "to": 20198 }, { "from": 22003, "to": 24657 }], "MD": [{ "from": 20601, "to": 21930 }], "WV": [{ "from": 24701, "to": 26884 }], "NC": [{ "from": 27006, "to": 28909 }], "SC": [{ "from": 29001, "to": 29945 }], "GA": [{ "from": 30002, "to": 31909 }, { "from": 39813, "to": 39897 }], "FL": [{ "from": 32003, "to": 34997 }], "AL": [{ "from": 35004, "to": 36925 }], "TN": [{ "from": 37010, "to": 38589 }], "MS": [{ "from": 38601, "to": 39776 }], "KY": [{ "from": 40003, "to": 42788 }], "OH": [{ "from": 43001, "to": 45899 }], "IN": [{ "from": 46001, "to": 47997 }], "MI": [{ "from": 48001, "to": 49971 }], "IA": [{ "from": 50001, "to": 52807 }], "WI": [{ "from": 53001, "to": 54986 }], "MN": [{ "from": 55001, "to": 56763 }], "SD": [{ "from": 57001, "to": 57799 }], "ND": [{ "from": 58001, "to": 58856 }], "MT": [{ "from": 59001, "to": 59937 }], "IL": [{ "from": 60002, "to": 62999 }], "MO": [{ "from": 63005, "to": 65810 }], "KS": [{ "from": 66002, "to": 67954 }], "NE": [{ "from": 68001, "to": 69367 }], "LA": [{ "from": 70001, "to": 71486 }], "AR": [{ "from": 71601, "to": 72959 }], "OK": [{ "from": 73002, "to": 74966 }], "TX": [{ "from": 75001, "to": 79942 }], "CO": [{ "from": 80002, "to": 81657 }], "WY": [{ "from": 82001, "to": 83128 }, { "from": 83414, "to": 83414 }], "ID": [{ "from": 83201, "to": 83406 }, { "from": 83420, "to": 83876 }], "UT": [{ "from": 84001, "to": 84790 }], "AZ": [{ "from": 85003, "to": 86556 }], "NM": [{ "from": 87001, "to": 88436 }], "NV": [{ "from": 89001, "to": 89883 }], "CA": [{ "from": 90001, "to": 96161 }], "HI": [{ "from": 96701, "to": 96863 }], "OR": [{ "from": 97001, "to": 97920 }], "WA": [{ "from": 98001, "to": 99403 }], "AK": [{ "from": 99501, "to": 99929 }] }
var rebateData = [{ "state": "ARIZONA", "code": "AZ", "name": "Tucson Electric Power Co", "link": "https://www.tep.com/energy-efficient-pools/", "amount": "$100" }, { "state": "CALIFORNIA", "code": "CA", "name": "Azusa Light & Water", "link": "http://www.ci.azusa.ca.us/documentcenter/view/5329", "amount": "$50" }, { "state": "CALIFORNIA", "code": "CA", "name": "City of Burbank", "link": "https://www.burbankwaterandpower.com/incentives-for-residents/residential-rebates-home-rewards", "amount": "$400" }, { "state": "CALIFORNIA", "code": "CA", "name": "City of Healdsburg", "link": "http://www.ci.healdsburg.ca.us/234/Rebates-Energy-Efficiency", "amount": "$125" }, { "state": "CALIFORNIA", "code": "CA", "name": "City of Palo Alto", "link": "https://www.cityofpaloalto.org/gov/depts/utl/residents/resrebate/smartenergy/pool_pumps.asp", "amount": "$200" }, { "state": "CALIFORNIA", "code": "CA", "name": "City of Riverside", "link": "https://www.riversideca.gov/utilities/businesses/rebates-energy.asp#menu13", "amount": "$200" }, { "state": "CALIFORNIA", "code": "CA", "name": "Glendale Water & Power", "link": "http://www.glendaleca.gov/smart-home-rebate-program", "amount": "$125" }, { "state": "CALIFORNIA", "code": "CA", "name": "Gridley Municipal Utilities", "link": "http://gridley.ca.us/documents-forms/", "amount": "$400" }, { "state": "CALIFORNIA", "code": "CA", "name": "Healdsburg Municipal Electric Department", "link": "http://www.ci.healdsburg.ca.us/234/Energy-Efficiency-Rebates", "amount": "$125" }, { "state": "CALIFORNIA", "code": "CA", "name": "Los Angeles Depart of Water and Power", "link": "https://www.ladwp.com/ladwp/faces/ladwp/residential/r-savemoney/r-sm-rebatesandprograms;jsessionid=xJ1jXtvQhFz0HZYB1QRNphb9cmYhrjzh9pTtxQnBVT1nFXLsNrgv!1911051811?_afrLoop=259237646323260&_afrWindowMode=0&_afrWindowId=null", "amount": "$1000" }, { "state": "CALIFORNIA", "code": "CA", "name": "Modesto Irrigation District", "link": "http://www.mid.org/rebates/home/", "amount": "$200" }, { "state": "CALIFORNIA", "code": "CA", "name": "Pasadena Water & Power", "link": "https://ww5.cityofpasadena.net/water-and-power/poolpumprebate/", "amount": "$450" }, { "state": "CALIFORNIA", "code": "CA", "name": "Roseville Electric", "link": "https://www.roseville.ca.us/cms/One.aspx?portalId=7964922&pageId=10478130", "amount": "$200" }, { "state": "CALIFORNIA", "code": "CA", "name": "Sacramento Municipal Utility Districts", "link": "https://www.smud.org/en/Rebates-and-Savings-Tips/Improve-Home-Efficiency", "amount": "$250" }, { "state": "CALIFORNIA", "code": "CA", "name": "Sonoma - PACE Financing", "link": "http://sonomacountyenergy.org/residential-programs/energy-upgrade-california/", "amount": "$125" }, { "state": "CALIFORNIA", "code": "CA", "name": "Southern California Edison", "link": "https://www.sce.com/wps/portal/home/residential/rebates-savings/rebates/", "amount": "$200" }, { "state": "FLORIDA", "code": "FL", "name": "City of Tallahassee", "link": "http://www.talgov.com/you/you-products-home-es-rebates.aspx", "amount": "$200" }, { "state": "FLORIDA", "code": "FL", "name": "Lakeland Electric", "link": "https://lakelandelectric.com/customers/save-energy/rebates#760189-appliance-rebate", "amount": "$200" }, { "state": "HAWAII", "code": "HI", "name": "Hawaii Energy", "link": "https://hawaiienergy.com/for-homes/rebates/additional-rebates", "amount": "$125" }, { "state": "ILLINOIS", "code": "IL", "name": "ComEd", "link": "https://www.comed.com/WaysToSave/ForYourHome/Pages/PoolPumpRebates.aspx", "amount": "$275" }, { "state": "INDIANA", "code": "IN", "name": "I&M", "link": "https://www.electricideas.com/home/home-energy-products-program/", "amount": "$100" }, { "state": "KENTUCKY", "code": "KY", "name": "Duke Energy", "link": "https://www.duke-energy.com/home/products/smart-saver/pool-pump", "amount": "$300" }, { "state": "LOUISIANA", "code": "LA", "name": "CLECO", "link": "https://www.cleco.com/documents/10180/26646796/2018+Cleco+Energy+Efficiency+Pool+Pump+Rebate.pdf/e6f918fe-740a-4c7e-9ea4-1e1a88de4383", "amount": "$250" }, { "state": "LOUISIANA", "code": "LA", "name": "Entergy New Orleans", "link": "https://www.energysmartnola.info/home-owners/appliances/pool-pumps", "amount": "$300" }, { "state": "MARYLAND", "code": "MD", "name": "Baltimore Gas & Electric (BGE)", "link": "http://www.bgesmartenergy.com/residential/appliance-rebates/pool-pumps", "amount": "$400" }, { "state": "MARYLAND", "code": "MD", "name": "Conectiv (Pepco Holding, Inc.)", "link": "https://homeenergysavings.pepco.com/appliance-rebate-program/overview/pool-pump", "amount": "$400" }, { "state": "MARYLAND", "code": "MD", "name": "Delmarva Power", "link": "https://homeenergysavings.delmarva.com/appliance-rebate-program/overview/pool-pump", "amount": "$400" }, { "state": "MARYLAND", "code": "MD", "name": "Potomac Edison", "link": "http://energysavemd-home.com/appliance/pool-pump-rebates/", "amount": "$400" }, { "state": "MARYLAND", "code": "MD", "name": "Southern Maryland Electric Cooperative", "link": "https://www.smeco.coop/save-energy-and-money/appliances", "amount": "$400" }, { "state": "MARYLAND", "code": "MD", "name": "SMECO", "link": "https://www.smeco.coop/save-energy-and-money/appliances", "amount": "$150 - $400" }, { "state": "MICHIGAN", "code": "MI", "name": "Bay City Electric Light & Power", "link": "http://www.baycityenergysmart.org/appliances-and-electronics-rebate.html", "amount": "$200" }, { "state": "MICHIGAN", "code": "MI", "name": "DTE Energy", "link": "https://www.newlook.dteenergy.com/wps/wcm/connect/dte-web/home/save-energy/residential/rebates/energy+star+appliances", "amount": "$350" }, { "state": "MISSOURI", "code": "MO", "name": "Ameren Missouri Residential Electric", "link": "https://www.efficientproductsrebate.com/", "amount": "$350" }, { "state": "NEW HAMPSHIRE", "code": "NH", "name": "New Hampshire Utility", "link": "https://nhsaves.com/rebates/pool-pumps/", "amount": "$500" }, { "state": "NEW MEXICO", "code": "NM", "name": "PNM", "link": "https://www.pnm.com/poolpump", "amount": "$300" }, { "state": "NEW YORK", "code": "NY", "name": "PSEG, formally known as Long Island Power Authority", "link": "https://www.psegliny.com/page.cfm/Efficiency/Appliances/PoolPumps", "amount": "$350" }, { "state": "NEW YORK", "code": "NY", "name": "South Fork Peak Savers", "link": "http://southforkpeaksavers.com/save/poolpumps/", "amount": "$250" }, { "state": "NORTH CAROLINA", "code": "NC", "name": "Duke Energy", "link": "https://www.duke-energy.com/home/products/smart-saver/pool-pump", "amount": "$300" }, { "state": "NORTH CAROLINA", "code": "NC", "name": "South River Electric Membership Corporation", "link": "http://www.sremc.com/content/pool-pumps", "amount": "$100" }, { "state": "OHIO", "code": "OH", "name": "Duke Energy", "link": "https://www.duke-energy.com/home/products/smart-saver/pool-pump", "amount": "$300" }, { "state": "OHIO", "code": "OH", "name": "Efficiency Smart Program", "link": "https://www.efficiencysmart.org/product-rebates", "amount": "$175" }, { "state": "PENNSYLVANIA", "code": "PA", "name": "Met-Ed (FirstEnergy)", "link": "http://energysavepa-home.com/appliance/pool-pump-rebates", "amount": "$150" }, { "state": "PENNSYLVANIA", "code": "PA", "name": "PECO Electric Utilities", "link": "https://www.peco.com/WaystoSave/ForYourHome/Pages/ApplianceRebates.aspx", "amount": "$200" }, { "state": "PENNSYLVANIA", "code": "PA", "name": "PenElec (FirstEnergy)", "link": "http://energysavepa-home.com/appliances/pool-pump-rebates", "amount": "$150" }, { "state": "PENNSYLVANIA", "code": "PA", "name": "PennPower (FirstEnergy)", "link": "http://energysavepa-home.com/appliances/pool-pump-rebates", "amount": "$150" }, { "state": "PENNSYLVANIA", "code": "PA", "name": "PPL Electric Utilities", "link": "https://pplelectricsavings.com/HomeEquipment/Products?utm_source=poolpump&utm_medium=allrebates&utm_campaign=pplwebsite", "amount": "$350" }, { "state": "PENNSYLVANIA", "code": "PA", "name": "West PennPower (FiRSTeNERGY)", "link": "http://energysavepa-home.com/appliances/pool-pump-rebates", "amount": "$150" }, { "state": "SOUTH CAROLINA", "code": "SC", "name": "Duke Energy", "link": "https://www.duke-energy.com/home/products/smart-saver/pool-pump", "amount": "$300" }, { "state": "TEXAS", "code": "TX", "name": "Austin Energy", "link": "https://savings.austinenergy.com/rebates/residential/offerings/appliances-and-equipment/pool-pump", "amount": "$300" }, { "state": "TEXAS", "code": "TX", "name": "CPS Energy", "link": "https://residential.savenow.cpsenergy.com/rebates?hsCtaTracking=906a36ac-cf80-4af9-8c87-d61ee5548321%7Ca1697402-6944-45f7-82e1-bc538820ca8c", "amount": "$150" }, { "state": "VERMONT", "code": "VT", "name": "Efficiency Vermont", "link": "https://www.efficiencyvermont.com/rebates/list/pool-pumps", "amount": "$600" }];
var vendorTemplate = $('#vendor-template').detach();
var productTemplate = $('#product-template').detach();

$('.rebate-form button').click(checkForm);

$($('.progressbar .item')[0]).click(function () {
	if (pageData.page == '' || pageData.page == null) return;
	$('.rebates-step').hide();
	$('#rebates-step-1').show();
	setProgress(1);
	history.pushState({ }, "Rebate Calculator", "./");
	pageData = {
	};
});

$($('.progressbar .item')[1]).click(function () {
	if (pageData.page == 'rebates') return;
	if (!$($('.progressbar li')[1]).hasClass('active')) {
		return;
	}
	history.pushState({ page: 'rebates', stateCode: pageData.stateCode, stateName: pageData.stateName, type: pageData.type }, "Rebate Calculator", "?page=rebates&stateCode=" + pageData.stateCode + "&stateName=" + escape(pageData.stateName) + "&type=" + pageData.type);
	pageData = {
		page: 'rebates',
		stateCode: pageData.stateCode,
		stateName: pageData.stateName,
		type: pageData.type,
	};
	$('.rebates-step').hide();
	$('#rebates-step-2').show();
	setProgress(2);
});

$($('.progressbar .item')[2]).click(function () {
	if (pageData.page == 'pumps') return;
	if (!$($('.progressbar li')[2]).hasClass('active')) {
		return;
	}
	history.pushState({ page: 'pumps', stateCode: pageData.stateCode, stateName: pageData.stateName, type: pageData.type, amount: pageData.amount }, "Rebate Calculator", "?page=pumps&stateCode=" + pageData.stateCode + "&stateName=" + escape(pageData.stateName) + "&type=" + pageData.type + "&amount=" + pageData.amount);
	pageData = {
		page: 'pumps',
		stateCode: pageData.stateCode,
		stateName: pageData.stateName,
		type: pageData.type,
		amount: pageData.amount
	};
	$('.rebates-step').hide();
	$('#rebates-step-3').show();
	setProgress(3);
});

var pageData = { };

window.onpopstate = function (event) {
	if (event.state != null && event.state.page != null) {
		pageData = {
			page : event.state.page,
			stateCode: event.state.stateCode,
			stateName : event.state.stateName,
			type: event.state.type,
			amount: event.state.amount
		};
		if (event.state.page == 'rebates') {
			showRebates(event.state.stateCode, event.state.stateName, event.state.type);
		} else if (event.state.page == 'pumps') {
			showProducts(event.state.type, event.state.amount);
		}
	} else {
		pageData = {

		};
		$('.rebates-step').hide();
		$('#rebates-step-1').show();
		setProgress(1);
	}
	
};

function checkForm() {
	var zip = parseInt($('#rebates-zip').val());
	var type = $('#rebates-pool-type').val();

	var stateCode = null;
	var stateName = null;
	for (var code in statesByZip) {
		var ranges = statesByZip[code];
		for (var i = 0; i < ranges.length; i++) {
			var range = ranges[i];
			if (zip >= range.from && zip <= range.to) {
				stateCode = code;
				break;
			}
		}
		if (stateCode != null) break;
	}

	if (stateCode == null) {
		$('#zip-error').show();
		return;
	}

	if (type == '') {
		$('#type-error').show();
		return;
	}
	$('#zip-error').hide();

	for (var i = 0; i < rebateData.length; i++) {
		if (rebateData[i].code == stateCode) {
			stateName = rebateData[i].state;
			break;
		}
	}
	history.pushState({ page: 'rebates', stateCode: stateCode, stateName: stateName, type: type }, "Rebate Calculator", "?page=rebates&stateCode=" + stateCode + "&stateName=" + escape(stateName) + "&type=" + type);
	pageData = {
		page: 'rebates',
		stateCode: stateCode,
		stateName : stateName,
		type: type,
	};

	showRebates(stateCode, stateName, type);
}
$(function () {
	//showRebates('ca', 'CALIFORNIA', 'above-ground');
});

function setProgress(step) {
	$($('.progressbar .item')[0]).toggleClass('active', step >= 1);
	$($('.progressbar .item')[0]).toggleClass('checked', step >= 2);
	$($('.progressbar .item')[1]).toggleClass('active', step >= 2);
	$($('.progressbar .item')[1]).toggleClass('checked', step >= 3);
	$($('.progressbar .item')[2]).toggleClass('active', step >= 3);
}

function showRebates(stateCode, stateName, type) {
	$('.rebates-step').hide();
	$('#rebates-step-2').show();
	$('.title-2').show();
	$('.title-1').hide();

	setProgress(2);

	var items = [];
	$('.vendor.vendor-item').remove();
	console.log(stateCode);
	for (var index in rebateData) {
		var item = rebateData[index];
		if (item.code.toLowerCase() == stateCode.toLowerCase()) {
			items.push(item);
		}
	}
	$('.rebate-region').show();
	//if (stateName != null) $('.rebate-title').text(stateName.toUpperCase());
	$('.rebate-title').toggle(stateName != null)
	$('.vendor.no-rebate').toggle(items.length == 0);

	for (var i = 0; i < items.length; i++) {
		var item = items[i];
		var vendor = vendorTemplate.clone();
		vendor.find('.vendor-name').text(item.name);
		vendor.find('.vendor-link a').attr('href', item.link);
		//vendor.find('.vendor-link a').text(item.link);
		//vendor.find('.vendorTL p a').attr('href', item.link);
		vendor.find('.vendor-rba').html(item.amount);
		vendor.find('.vendor-button').attr('data-amount', item.amount);
		vendor.find('.vendor-button').click(function () {
			var amount = $(this).attr('data-amount');
			amount = parseFloat(amount.replace('$', ''));
			window.open("?page=pumps&stateCode=" + stateCode + "&stateName=" + escape(stateName) + "&type=" + type + "&amount=" + escape(amount), '_blank');
			return;
			history.pushState({ page: 'pumps', stateCode: stateCode, stateName: stateName, type: type, amount: amount }, "Rebate Calculator", "?page=pumps&stateCode=" + stateCode + "&stateName=" + escape(stateName) + "&type=" + type + "&amount=" + escape(amount));
			pageData = {
				page : 'pumps',
				stateCode: stateCode,
				stateName: stateName,
				type: type,
				amount:amount
			};
			showProducts(type, amount);
		});
		$('.vendor-container').append(vendor);
	}

}
var formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2
});
var rebateAmount = 0;
function showProducts(type, amount) {
	setProgress(3);
	$('.rebates-step').hide();
	$('#rebates-step-3').show();
	$('.vs-products-container.above-ground').toggle(type == "above-ground");
	$('.vs-products-container.in-ground').toggle(type == "in-ground");
	
	rebateAmount = amount;

	$('.price-rebated').each(function () {
		var price = parseFloat($(this).attr('data-price'));
		price -= amount;
		price = Math.round(price * 100) / 100;
		$(this).text(formatter.format(price));
	});
}

$.getJSON("/collections/variable-speed-pumps/products.json", function (data) {
	for (var i = 0; i < data.products.length; i++) {
		var item = data.products[i];
		var product = productTemplate.clone();
		product.find('img').attr('src', item.images[0].src);
		product.find('.vs-product-title').text(item.title);
		product.find('.price-rebated').text('$' + (item.variants[0].price - rebateAmount));
		product.find('.price-rebated').attr('data-price', item.variants[0].price);
		product.find('.price-regular').text('$' + item.variants[0].price);
		product.find('a').attr('href', '/products/' + item.handle);

		$('.in-ground .vs-products').append(product);

	}
});

$.getJSON("/collections/variable-speed-pumps/products.json", function (data) {
	for (var i = 0; i < data.products.length; i++) {
		var item = data.products[i];
		var product = productTemplate.clone();
		product.find('img').attr('src', item.images[0].src);
		product.find('.vs-product-title').text(item.title);
		product.find('.price-rebated').text('$' + (item.variants[0].price - rebateAmount));
		product.find('.price-rebated').attr('data-price', item.variants[0].price);
		product.find('.price-regular').text('$' + item.variants[0].price);
		product.find('a').attr('href', '/products/' + item.handle);

		$('.above-ground .vs-products').append(product);
	}
});



function initPage() {
	var urlParams = new URLSearchParams(window.location.search);
	var page = urlParams.get('page');
	var stateCode = urlParams.get('stateCode');
	var stateName = urlParams.get('stateName');
	var type = urlParams.get('type');
	var amount = urlParams.get('amount');
	if (page != null) {
		pageData = {
			page: page,
			stateCode: stateCode,
			stateName: stateName,
			type: type,
			amount: amount
		};
		if (page == 'rebates') {
			showRebates(stateCode, stateName, type);
		} else if (page == 'pumps') {
			showProducts(type, amount);
		}
	}
}
initPage();